import React from "react";
import { useParams } from "react-router-dom";
import RegionalPlansPage from "./RegionalPlansPage";

/**
 * Ads-only checkout: pure one-time ad-credit packs, no plan.
 * URL pattern: /ads/:adSlug (e.g. /ads/launch-1)
 *
 * Wraps RegionalPlansPage with region="ads" and version=adSlug so the
 * regional-plans pipeline (config fetch, Razorpay intent, payment.captured
 * webhook → swipePageFunction → access code) is reused unchanged. The
 * page-level differences (hero copy, "ads" sources, cancel URL, no
 * billing-cycle toggle, type='ad-credits' through swipePlanMapping) are
 * driven by integrations-server config plus the small region-aware
 * branches inside RegionalPlansPage.
 */
const AdsCheckoutPage = () => {
  const { adSlug } = useParams();
  return <RegionalPlansPage region="ads" version={adSlug} />;
};

export default AdsCheckoutPage;
